import { render, staticRenderFns } from "./BodyInstrument.vue?vue&type=template&id=7adbbefb&scoped=true"
import script from "./BodyInstrument.vue?vue&type=script&lang=js"
export * from "./BodyInstrument.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=7adbbefb&prod&scoped=true&lang=css&external"
import style1 from "./BodyInstrument.vue?vue&type=style&index=1&id=7adbbefb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adbbefb",
  null
  
)

export default component.exports